import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const ButtonChildren = ({
	Icon,
	IconRight,
	onCancel,
	children,
}) => {
	if (typeof Icon !== 'undefined') {
		return (
			<div>
				<span className={styles.icon}>
					<Icon />
				</span>
				{typeof IconRight !== 'undefined' && (
					<span role="presentation" className={styles.iconRight} onClick={onCancel}>
						<IconRight />
					</span>
				)}
				<span>{children}</span>
			</div>
		);
	}

	return <div>{children}</div>;
};

// Component has four state: normal, focus, selected, disabled
const Button = ({
	className,
	color = 'basic',
	children,
	state = 'normal',
	onClick,
	onCancel,
	Icon,
	IconRight,
	square = false,
	...props
}) => (
	<button
		className={classnames(styles[color], className, {
			[styles.disabled]: state === 'disabled',
			[styles.selected]: state === 'selected',
			[styles.focus]: state === 'focus',
			[styles.icon]: typeof Icon !== 'undefined' && color !== 'google' && color !== 'facebook',
			[styles.iconRight]: typeof IconRight !== 'undefined',
			[styles.square]: square,
		})}
		onClick={e => {
			if (state === 'normal' || state === 'focus') {
				onClick(e);
			}
		}}
		{...props}
	>
		<ButtonChildren Icon={Icon} IconRight={IconRight} onCancel={onCancel}>
			{children}
		</ButtonChildren>
	</button>
);

export default Button;



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js